// Presenter Mode: viewer-session state for live demos on real dealer accounts.
// Blurs customer & dealer identity on screen. FBI-only; never persisted to the
// rooftop record. Session-scoped so it survives route changes, reloads, and
// rooftop switches within the tab.
export const STATE_KEY = 'presenter'
export const SET_PRESENTER_MODE = 'SET_PRESENTER_MODE'
export const SESSION_KEY = 'vl.presenterMode'

const readInitial = () => {
  try {
    return sessionStorage.getItem(SESSION_KEY) === '1'
  } catch (e) {
    return false
  }
}

const initialState = { on: readInitial() }

export default function presenterReducers(state = initialState, action) {
  switch (action.type) {
    case SET_PRESENTER_MODE:
      return { ...state, on: !!action.on }
    default:
      return state
  }
}
